export const AUTH_URL_SIGN_IN = `${process.env.GATSBY_AUTH_HOST}/auth/sign-in`;
export const AUTH_URL_SIGN_OUT = `${process.env.GATSBY_AUTH_HOST}/auth/sign-out`;
export const AUTH_URL_REFRESH_TOKEN = `${process.env.GATSBY_AUTH_HOST}/auth/refresh-token`;

export const GRAPHQL_HOST = process.env.GATSBY_GRAPHQL_HOST ?? '';
